// StepTextResponse — 文字回應輸入框（純 controlled component）。
// Spec: docs/specs/location-tasks.md §8.5.1.
//
// 文字 = 證據資料，不該帶自己的「儲存」按鈕。WizardRunner 持有
// pendingText state，在使用者按下「完成」(handleSubmit) 時統一隨
// status='submitted' 一起 PATCH 上去。Step 元件本身只是 textarea +
// 字數計，零 state、零 PATCH、零 button。
//
// Design：state-machine transition (in_progress → submitted) 是唯一
// commit point，由 handleSubmit 拍板；所有 step 元件只專注「拿資料」。

import React from "react";

const MAX_LEN = 500;

interface Props {
  text: string;
  onTextChange: (next: string) => void;
  /** Override default 500 char limit if a future task type needs it.
   *  Server-side is also 500, see evidence.ts; bumping here without
   *  bumping there will surface as a 422 on submit. */
  maxLen?: number;
}

export default function StepTextResponse({ text, onTextChange, maxLen = MAX_LEN }: Props): React.ReactElement {
  return (
    <div className="space-y-2">
      <textarea
        value={text}
        onChange={(e) => onTextChange(e.target.value.slice(0, maxLen))}
        rows={5}
        placeholder="現場觀察、處置、結果說明…"
        className="w-full rounded-lg bg-bg-raised border border-border p-3 text-sm text-text-primary"
      />
      <p className="text-2xs text-text-muted">{text.length} / {maxLen}</p>
    </div>
  );
}
